"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: left;\n  margin: 0;\n  height: 4rem;\n  color: rgba(255, 255, 255, 0.96);\n  background: rgba(0, 0, 0, 0.32);\n  padding: 0 0.375rem;\n"])));

var StyledLabel = _styledComponents.default.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 0.635rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledValue = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  height: 24px;\n  line-height: 24px;\n"])));

var StyledRank = _styledComponents.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 64px;\n  min-width: 64px;\n  max-width: 64px;\n  width: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  font-size: ", ";\n  ", ";\n"])), function (p) {
  return p.isLongRank ? "1.25rem" : "1.5rem";
}, function (p) {
  return p.isActive ? "color: #fff" : "";
});

var StyledUserName = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  min-width: 1px;\n  margin-left: 1rem;\n  font-family: ", ";\n  font-size: 1rem;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  ", ";\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.isActive ? "color: #fff" : "";
});

var StyledPrize = _styledComponents.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin: 0 0.5rem;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.96);\n"])));

var StyledPoints = _styledComponents.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  flex: 0 0 50px;\n  text-align: center;\n  font-size: 1.5rem;\n  ", ";\n"])), function (p) {
  return p.isActive ? "color: #fff" : "";
});

var Wrapper = function Wrapper(_ref) {
  var _row$rank;

  var row = _ref.row,
      index = _ref.index,
      isSkeleton = _ref.isSkeleton,
      isPreMatchLeaderboard = _ref.isPreMatchLeaderboard,
      isDutch = _ref.isDutch,
      showLabels = _ref.showLabels,
      onRowClicked = _ref.onRowClicked;
  var prize = (row === null || row === void 0 ? void 0 : row.prize) || (row === null || row === void 0 ? void 0 : row.promoPrize);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    onClick: onRowClicked,
    children: isSkeleton ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledRank, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
          skeletonWidth: "22px",
          skeletonHeight: "24px"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
        isCircle: true,
        skeletonWidth: "34px",
        skeletonHeight: "34px"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUserName, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Skeleton, {
          display: "block",
          skeletonWidth: index % 3 === 0 ? "200px" : index % 3 === 1 ? "120px" : index % 3 === 2 ? "70px" : "20px",
          skeletonHeight: "24px"
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRank, {
        isLongRank: (row === null || row === void 0 ? void 0 : (_row$rank = row.rank) === null || _row$rank === void 0 ? void 0 : _row$rank.toString().length) > 2,
        children: [showLabels && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
          children: "Rank"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledValue, {
          children: !isPreMatchLeaderboard && row !== null && row !== void 0 && row.rank ? row.rank : "-"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Avatar, {
        size: "34px",
        src: row.user.image
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledUserName, {
        children: row.user.username
      }), !isPreMatchLeaderboard && prize > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPrize, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_.PenceToPounds, {
          showCurrencySymbol: true,
          isDutch: isDutch,
          children: prize
        })
      }), !isPreMatchLeaderboard && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPoints, {
        children: [showLabels && (row === null || row === void 0 ? void 0 : row.points) > -1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
          children: "Points"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledValue, {
          children: row.points > -1 ? row.points : "-"
        })]
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;